<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Exclusive</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the content of the Exclusive?
              </div>
              <v-text-field
                v-model="data.content"
                hide-details
                dense
                outlined
                placeholder="Exclusive Content"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Expires At</div>
              <v-text-field
                v-model="expiresAtDateString"
                readonly
                hide-details
                dense
                outlined
                placeholder="Expire Date"
                @click="openExpiryDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-autocomplete
                :loading="loading"
                v-model="entity"
                :items="reviewedEntities"
                cache-items
                :search-input.sync="searchTerm"
                hide-details
                return-object
                item-text="title"
                item-value="title"
                placeholder="Select Entity"
                no-data-text="Type a name of an entity to search"
                outlined
                chips
                dense
                @change="entitySelected"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                readonly
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Vibez Options</div>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Cost</div>
              <v-text-field
                v-model="data.cost"
                hide-details
                dense
                type="number"
                outlined
                placeholder="Ex: 5"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">How many Redeems?</div>
              <v-text-field
                v-model="data.redeemsLeft"
                hide-details
                dense
                type="number"
                outlined
                placeholder="Ex: 5"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <v-checkbox
                label="Is Unlimited?"
                hide-details
                v-model="data.isUnlimited"
              />
              <v-checkbox
                label="Is GeoFenced?"
                hide-details
                v-model="data.isGeoFenced"
              />
              <v-checkbox
                label="Has daily limit?"
                hide-details
                v-model="data.hasDailyLimit"
              />
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Link Button Options</div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Name</div>
              <v-text-field
                v-model="data.link.name"
                hide-details
                dense
                outlined
                placeholder="Ex: Name"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Url</div>
              <v-text-field
                v-model="data.link.url"
                hide-details
                dense
                outlined
                placeholder="Ex: Url"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <!-- <image-upload-section
            ref="exclusiveImageUploadRef"
            @selectedImage="setExclusiveImage"
          /> -->
          <gallery-image-select-section
            ref="exclusiveImageUploadRef"
            @imageSelected="setExclusiveImage"
          />
          <v-layout v-if="data.image.url" class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Image URL</div>
              <v-text-field
                v-model="data.image.url"
                hide-details
                dense
                outlined
                readonly
                placeholder="Ex: gift"
              ></v-text-field>
            </v-flex>
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Image Thumbnail</div>
              <v-text-field
                v-model="data.image.thumbnail"
                hide-details
                readonly
                dense
                outlined
                placeholder="Ex: gift"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Next Step Options</div>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Message</div>
              <v-text-field
                v-model="data.subCollections.toInsert.message"
                hide-details
                dense
                outlined
                placeholder="Message"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <!-- <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Collection Name</div>
              <v-text-field
                v-model="data.subCollections.collectionName"
                hide-details
                dense
                outlined
                placeholder="Collection Name"
              ></v-text-field>
            </v-flex>
          </v-layout> -->

          <!-- <image-upload-section
            ref="nextStepImageUploadRef"
            @selectedImage="setNextStepImage"
          /> -->
          <gallery-image-select-section
            ref="nextStepImageUploadRef"
            @imageSelected="setNextStepImage"
          />
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Schedule
        </v-btn>
      </v-card-actions>
    </v-card>
    <time-and-date-select-dialog
      @onDateSelected="onExpiryDateSelected"
      ref="ExpiryTimeAndDateDialogRef"
    />
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
    <!-- <image-cropper-dialog
      @croppedImage="saveCroppedImage"
      ref="ImageCropperDialogRef"
    /> -->
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import firebase from 'firebase';
import _ from 'lodash';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
// import ImageUploadSection from './ImageUploadSection';
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';
// import ImageCropperDialog from "./ImageCropperDialog.vue";
export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
    // ImageUploadSection,
    GalleryImageSelectSection,
    // ImageCropperDialog,
  },

  data() {
    return {
      dialog: false,
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: '',
      expiresAtDateField: '',
      scheduledAt: '',
      region: '',
      state: '',
      createdBy: '',
      entity: {},
      loading: false,
      searchTerm: '',
      data: {
        entityId: '',
        content: '',
        cost: 0,
        image: {
          thumbnail: '',
          url: '',
          firebaseUrl: '',
        },
        link: {
          name: '',
          url: '',
        },
        isUnlimited: false,
        isGeoFenced: false,
        hasDailyLimit: false,
        location: {
          latitude: '',
          longitude: '',
        },
        redeemsLeft: 0,
        expiresAt: '',
        subCollections: {
          image: {
            firebaseUrl: '',
            url: '',
            thumbnail: '',
          },
          collectionName: '',
          toInsert: {
            attachment: '',
            for: 'user',
            message: '',
            state: '',
          },
        },
      },
      selectedNextStepFromGallery: false,
      selectedExclusiveFromGallery: false,
      exclusiveImage: [],
      nextStepImage: [],
      // images: [],
    };
  },

  computed: {
    ...mapState('$_home', ['regions']),
    ...mapState('$_entity', ['reviewedEntities']),

    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    expiresAtDateString() {
      if (this.expiresAtDateField) {
        return this.iMoment(this.expiresAtDateField);
      } else {
        return this.data.expiresAt;
      }
    },

    changeFields() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: 'scheduled',

        type: 'exclusive',
        region: this.region,
        entity: this.entity,
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        data: {
          entityId: this.entity.id,
          content: this.data.content,
          cost: Number(this.data.cost),
          image: {
            thumbnail: this.data.image.thumbnail,
            url: this.data.image.url,
            firebaseUrl: this.data.image.firebaseUrl,
          },
          link: {
            name: this.data.link.name,
            url: this.data.link.url,
          },
          isUnlimited: this.data.isUnlimited,
          isGeoFenced: this.data.isGeoFenced,
          hasDailyLimit: this.data.hasDailyLimit,
          location: this.entity.location
            ? new firebase.firestore.GeoPoint(
                parseFloat(this.entity.location.latitude),
                parseFloat(this.entity.location.longitude),
              )
            : new firebase.firestore.GeoPoint(
                parseFloat(this.region.latitude),
                parseFloat(this.region.longitude),
              ),
          redeemsLeft: Number(this.data.redeemsLeft),
          expiresAt: this.iMoment(this.expiresAtDateString),
          totalRedeemed: Number(0),
          subCollections: {
            image: {
              firebaseUrl: this.data.subCollections.image.firebaseUrl,
              url: this.data.subCollections.image.url,
              thumbnail: this.data.subCollections.image.thumbnail,
            },
            collectionName: 'nextstep',
            toInsert: {
              attachment: this.data.subCollections.image.url,
              for: 'user',
              message: this.data.subCollections.toInsert.message,
              state: '',
            },
          },
        },
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
  },
  methods: {
    ...mapActions({
      createNewExclusive: '$_content/createNewContent',
      uploadImage: '$_content/uploadImage',
      getEntities: '$_entity/getContent',
      getRegions: '$_home/getContent',
      getExclusives: '$_content/getContent',
      getExclusivesByRegion: '$_content/getContentByRegion',
      searchEntitiesAction: '$_entity/searchContent',
    }),
    entitySelected(entity) {
      console.log('Selected Entity: ', entity);
      if (entity) {
        this.region = entity.region;
      }
    },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchEntitiesAction({
        collection: 'entities',
        mutation: 'updateReviewedEntities',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(
        this.expiresAtDateField,
      );
    },
    onExpiryDateSelected(dateTime) {
      // console.log("Expiry Selected Date and Time: ", dateTime);
      this.expiresAtDateField = dateTime;
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    setExclusiveImage(image) {
      this.selectedExclusiveFromGallery = image ? true : false;
      this.data.image = image;
      //  this.exclusiveImage = image;
    },
    setNextStepImage(image) {
      console.log('Next Step', image);
      this.selectedNextStepFromGallery = image ? true : false;
      this.data.subCollections.image = image;
      //  this.nextStepImage = image;
    },
    cancel() {
      this.scheduledAtDateField = '';
      this.expiresAtDateField = '';
      this.scheduledAt = '';
      this.region = '';
      this.state = '';
      this.entity = {};
      this.data = {
        entityId: '',
        content: '',
        cost: 0,
        image: {
          thumbnail: '',
          url: '',
          firebaseUrl: '',
        },
        link: {
          name: '',
          url: '',
        },
        isUnlimited: false,
        isGeoFenced: false,
        hasDailyLimit: false,
        location: {
          latitude: '',
          longitude: '',
        },
        redeemsLeft: 0,
        expiresAt: '',
        subCollections: {
          image: {
            firebaseUrl: '',
            url: '',
            thumbnail: '',
          },
          collectionName: '',
          toInsert: {
            attachment: '',
            for: 'user',
            message: '',
            state: '',
          },
        },
      };
      this.dialog = false;
      if (this.selectedExclusiveFromGallery == true) {
        this.$refs.exclusiveImageUploadRef.galleryImageDeselect();
      }

      if (this.selectedNextStepFromGallery == true) {
        this.$refs.nextStepImageUploadRef.galleryImageDeselect();
      }

      this.selectedExclusiveFromGallery = false;
      this.selectedNextStepFromGallery = false;
    },
    save() {
      console.log(this.changeFields);

      if (Object.keys(this.changeFields.entity).length === 0) {
        return alert('Entity is missing yo... smh...');
      }

      this.createNewExclusive({
        details: this.changeFields,
        collection: this.collection,
        type: 'Exclusive',
      }).then(() => {
        this.dialog = false;
        this.getExclusivesByRegion({
          type: 'exclusive',
          collection: this.collection,
          mutation: 'updateExclusives',
          region: this.selectedRegion,
        });
      });
    },
  },
};
</script>

<style>
.cropper {
  height: 600px;
  background: #ddd;
}
</style>
